// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { fetchOidcDiscovery } from '@api/portalServices';
import type { OidcDiscoveryResponse } from '@api/types';
import type { ApiError } from '@errorHandler/errors';
import { QueryKey } from '@portal/constants';
import { useQuery } from '@tanstack/react-query';

export const useOidcDiscoveryQuery = (tenantId: string | undefined) =>
  useQuery<OidcDiscoveryResponse, ApiError>({
    queryKey: [QueryKey.OIDC_APP_DISCOVERY, tenantId],
    queryFn: () => fetchOidcDiscovery(tenantId ?? ''),
    enabled: Boolean(tenantId),
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
